module.exports = __webpack_public_path__ + "img/fileexplorer.12624c5a.png";